import React from "react";
import PropTypes from "prop-types";
import { removeAccents } from "../../../../../helpers/strings";

const allColumns = [
  "Nombre",
  "Apellido paterno",
  "Apellido materno",
  "RUT",
  "Sexo",
  "Remuneración imponible",
  "Movimiento personal",
  "Fecha inicio movimiento",
  "Fecha término movimiento",
];

class WorkersTable extends React.Component {
  constructor(props) {
    super(props);

    this.state = {};
  }

  render() {
    const { workers } = this.props;

    return (
      <div className="workers-table">
        <div className="workers-table-header">
          {allColumns.map((col) => (
            <div key={col}>{col}</div>
          ))}
        </div>

        {workers.map((worker, i) => (
          i % 2 === 0
          ? <div key={worker.nombre} className="workers-table-row">
              {allColumns.map((col) => (
                <div key={col}>{worker[removeAccents(col.toLowerCase())]}</div>
              ))}
            </div>
          : <div key={worker.nombre} className="workers-table-row-odd">
              {allColumns.map((col) => (
                <div key={col}>{worker[removeAccents(col.toLowerCase())]}</div>
              ))}
            </div>
          ))
        }
      </div>
    );
  }
}

WorkersTable.propTypes = {
  workers: PropTypes.array.isRequired,
};

export default WorkersTable;
